// const Layout1Settings = {
//     leftSidebar: {
//       show: true,
//       mode: 'compact', // full, close, compact, mobile,
//       theme: 'whiteBlue', // View all valid theme colors inside AppTheme/themeColors.js
//       bgImgURL: '/assets/sidebar/sidebar-bg-dark.jpg',
//     },
//     topbar: {
//       show: true,
//       fixed: true,
//       theme: 'whiteBlue', // View all valid theme colors inside MatxTheme/themeColors.js
//     },
//     footerbar: {
//       show: true,
//       fixed: false,
//       theme: 'whiteBlue', // View all valid theme colors inside MatxTheme/themeColors.js
//     },
//   };
  
//   export default Layout1Settings;

const Layout1Settings = {
  leftSidebar: {
    show: true,
    mode: 'compact', // full, close, compact, mobile
    theme: 'whiteBlue',
    bgImgURL: '/assets/sidebar/sidebar-bg-dark.jpg',
  },
  topbar: {
    show: true,
    fixed: true,
    theme: 'whiteBlue',
    height: 75,          // 👈 default height
    expandedHeight: 150, // 👈 when dropdown open
    expanded: false,     // 👈 track state (optional)
  },
  footerbar: {
    show: true,
    fixed: false,
    theme: 'whiteBlue',
  },
};

export default Layout1Settings;
